import React from 'react';
import { node } from 'prop-types';
import styles from './styles.scss';

var Category = function Category(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: styles.categoryLabel, 'data-hook': 'menu-navigation-category' },
    children
  );
};

Category.propTypes = {
  children: node
};

export default Category;
//# sourceMappingURL=Category.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/Category.js